import { umsgKpiPerformance } from 'bl/umsgs.bl';
import H from 'constants/httpMethod.const';
import MS from 'constants/time/ms.const';
import createFromDtoToStylistsPerfInfo from 'dto/kpi/createFromDtoToBusinessPerfInfo.dto';
import { fromAnyDateToIso } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

const L = logger('beKpiBusinessPerformance'); // eslint-disable-line no-unused-vars

// SEE: https://github.com/getslick/api.core/blob/staging/docs/KPI_performance.md

const reconfigure = (config) => (options, extra) => {
  const bgn = fromAnyDateToIso(extra?.bgn) || null;
  const end = fromAnyDateToIso(extra?.end) || null;

  return {
    ...options,
    ...config,
    params: { bgn, end },
    isMissingParams: !bgn || !end,
    fromDto: createFromDtoToStylistsPerfInfo({ bgn, end }),
    umsg: umsgKpiPerformance,
    timeout: 27.5 * MS.second,
  };
};

export const ibeKpiBusinessPerformancesRead = actionEndpointBe(
  'ibeKpiBusinessPerformancesRead',
  H.get,
  'metrics/kpi/business/performance/:salonId/:bgn/:end/',
  reconfigure({ inert: true }),
);

export const abeKpiBusinessPerformancesRead = actionEndpointBe(
  'abeKpiBusinessPerformancesRead',
  H.get,
  'metrics/kpi/business/performance/:salonId/:bgn/:end/',
  reconfigure({ inert: false }),
);
